<template>
    <div class="main-container">
        <el-form :inline="true" :model="searchForm" size="small" ref="searchForm" @keyup.enter.native="handleSearch" label-width="90px">
            <el-form-item label="小程序名称" prop="appName">
                <el-input v-model="searchForm.appName" placeholder="小程序名称" style="width: 230px"></el-input>
            </el-form-item>
            <el-form-item label="appId" prop="appId">
                <el-input v-model="searchForm.appId" placeholder="appId" style="width: 230px"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="handleSearch" size="small">查询</el-button>
                <el-button @click="handleReset" size="small">重置</el-button>
            </el-form-item>
        </el-form>

        <div style="padding-bottom: 10px">
            <el-button  icon="el-icon-plus" type="primary" size="small" @click="handleAdd">添加</el-button>
        </div>

        <el-table :data="appList" border style="width: 100%" size="small"  v-loading="isLoading" element-loading-text="拼命加载中">
            <el-table-column type="index" prop="index" label="#" width="60" align="center" fixed="left"></el-table-column>
            <el-table-column prop="appName" label="小程序名称" width="200"></el-table-column>
            <el-table-column prop="type" label="类型">
                <template slot-scope="{ row }">
                    <el-tag>{{row.type === 1 ? '支付端' : '小程序后台'}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="appId" label="appId" width="120"></el-table-column>
            <el-table-column prop="secret" label="appSecret" width="220"></el-table-column>
            <el-table-column prop="principalName" label="商户主体" width="200"></el-table-column>
            <el-table-column prop="wxSign" label="原始Id" width="150"></el-table-column>
            <el-table-column prop="mchId" label="商户号" width="120"></el-table-column>
            <el-table-column prop="qrCode" label="二维码图片" width="120">
                <template slot-scope="{ row }">
                    <el-image  style="width: 50px; height: 50px" :src="row.qrCode"  :preview-src-list="[row.qrCode]"></el-image>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="120" align="center" prop="action" fixed="right">
                <template slot-scope="{ row, index }">
                    <el-button type="text" size="mini" style="margin-right: 5px" @click="handleEdit(row)">编辑</el-button>
                    <el-button type="text" size="mini" style="color:red" @click="handleDelete(row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="text-align: right; padding: 10px 20px 0 0;">
            <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="total" :page-sizes="[10, 20, 50]"  :current-page.sync="searchForm.pageNumber" :page-size="searchForm.pageSize" @current-change="handleChangePage" @size-change="handleChangePageSize"></el-pagination>
        </div>

        <el-dialog :title="modelForm.id ? '编辑小程序' : '新增小程序'" :visible.sync="isShow" width="750px">
            <el-form ref="modelForm" :model="modelForm" inline label-width="90px" size="small" :rules="modelFormValidate">
                <el-form-item label="app名称" prop="appName">
                    <el-input type="text" v-model="modelForm.appName" clearable placeholder="请输入app名称" style="width: 230px"/>
                </el-form-item>

                <el-form-item label="小程序类型" prop="type">
                    <el-radio-group v-model="modelForm.type">
                        <el-radio :label="1">支付端</el-radio>
                        <el-radio :label="2">手机后台</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="appId" prop="appId">
                    <el-input type="text" v-model="modelForm.appId" clearable placeholder="请输入appId" style="width: 230px"/>
                </el-form-item>
                
                <el-form-item label="appSecret" prop="secret">
                    <el-input type="text" v-model="modelForm.secret" clearable placeholder="请输入appSecret" style="width: 230px"/>
                </el-form-item>

                <el-form-item label="商户主体" prop="principalName">
                    <el-input type="text" v-model="modelForm.principalName" clearable placeholder="请输入商户主体名称" style="width: 230px"/>
                </el-form-item>

                <el-form-item label="原始Id" prop="wxSign">
                    <el-input type="text" v-model="modelForm.wxSign" clearable placeholder="请输入原始Id" style="width: 230px"/>
                </el-form-item>

                <el-form-item label="商户号" prop="mchId">
                    <el-input type="text" v-model="modelForm.mchId" clearable placeholder="请输入商户号" style="width: 230px"/>
                </el-form-item>

                <el-form-item label="二维码图片" prop="qrCode">
                    <el-upload
                        class="avatar-uploader"
                        action="/room/upload/img"
                        :headers="headers"
                        name="mulFile"
                        :data="{ key: 'head'}"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload">
                        <img v-if="modelForm.qrCode" :src="modelForm.qrCode" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="关联小程序后台">
                    <el-select v-model="modelForm.withdrawAppId" placeholder="请输入后台小程序名称" style="width: 230px;" filterable clearable remote :remote-method="remoteMethodAppId" :loading="loading">
                        <el-option v-for="(item,key) in appIdList" :key="key" :label="item.appName" :value="item.appId">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button type="text" size="small" @click="isShow = false">取消</el-button>
                <el-button type="primary" size="small" :loading="submitLoading" @click="handleSubmit('modelForm')">提交</el-button>
            </div>
        </el-dialog>
    </div>
</template>


<script>
export default {
    computed: {
        headers() {
            return {
                "Authorization":  localStorage.getItem('Token'),
            }
        },
        
    },
    data() {
        
        return {
            appList: [],
            appIdList: [],
            loading: false,
            total: 0,
            searchForm: {
                appType: 1,
                appName: "",
                appId: "",
                pageNumber: 1,
                pageSize: 10,
            },
            isLoading: false,
            isShow: false,
            modelForm: {
                appName: "",
                appType: 1,
                type: 1,
                appId: "",
                withdrawAppId: '',
                secret: "",
                principalName: "",
                wxSign: '',
                mchId: "",
                qrCode: ""
            },
            accessToken: {},
            modelFormValidate: {
                appName: [{ required: true, message: "请输入小程序名称", trigger: "blur" }],
                withdrawAppId:[{ required: true, message: "请选择关联后台小程序", trigger: "blur" }],
                appId: [{ required: true, message: "请输入appId", trigger: "blur" }],
                secret: [{ required: true, message: "请输入appSecret", trigger: "blur" }],
                principalName: [{ required: true, message: "请输入商户主体名称", trigger: "blur" }],
                wxSign: [{ required: true, message: "请输入原始Id", trigger: "blur" }],
                mchId: [{ required: true, message: "请输入商户号", trigger: "blur" }],
            },
            submitLoading: false,

        }
    },
    created() {
       
        this.getAppList();
    },
    methods: {
        remoteMethodAppId(string){
            this.getRequest(`/df-wx/wxApp/getAllByType?type=2&searchName=${string}`)
            .then(res => {
                this.isLoading = false;
                let data = res.data;
                if(data.code == 200) {
                    this.appIdList = data.data;
                }
            })
        },
        handleSubmit(formName) {
            this.$refs[formName].validate((valid) => {
                if(valid) {
                    if(!!this.modelForm.id) {
                        this.postRequest("/df-wx/wxApp/updateWxApp", this.modelForm)
                        .then(res => {
                            let data = res.data;
                            if(data.code == 200) {
                                this.isShow = false;
                                this.getAppList();
                                this.$message.success(data.msg);
                            } else {
                                this.$message.warning(data.msg);
                            }
                        })
                    } else {
                        this.postRequest("/df-wx/wxApp/addWxApp", this.modelForm)
                        .then(res => {
                            let data = res.data;
                            if (data.code == 200) {
                                this.isShow = false;
                                this.getAppList();
                                this.$message.success(data.msg);
                            } else {
                                this.$message.warning(data.msg);
                            }
                        })
                    }
                }
            })
        },
        handleEdit(row) {
            this.getRequest(`/df-wx/wxApp/getById?id=${row.id}`)
            .then(res => {
                this.isLoading = false;
                let data = res.data;
                if(data.code == 200) {
                    this.modelForm = data.data;
                    this.isShow = true;
                }
            })
        },
        handleDelete(row) {
            this.$confirm('确认删除该小程序, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.postRequest("/df-wx/wxApp/deleteBatchWxApp",[row.id])
                .then(res => {
                    let data = res.data;
                        if (data.code == 200) {
                            this.getAppList();
                            this.$message.success(data.msg);
                        } else {
                            this.$message.warning(data.msg);
                        }
                })
            })
        },
        handleAdd() {
            this.modelForm = {
                appName: "",
                appType: 1,
                type: 1,
                appId: "",
                secret: "",
                principalName: "",
                wxSign: '',
                mchId: "",
                qrCode: ""
            }
            this.isShow = true;
        },
        handleAvatarSuccess(res, file) {
            this.modelForm.qrCode = res.data;
            console.log(res, this.modelForm);

        },
        beforeAvatarUpload(file) {
            const isJPG = (file.type === 'image/jpeg') || (file.type === 'image/png');
            const isLt2M = file.size / 1024 / 1024 < 10;

            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 10MB!');
            }
            return isJPG && isLt2M;
        },
        handleReset() {
            this.searchForm = {
                appType: 1,
                appName: "",
                appId: "",
                pageNumber: 1,
                pageSize: 10,
            };
            this.getAppList();
        },
        handleSearch() {
            this.searchForm.pageNumber = 1;
            this.getAppList();
        },
       
        handleChangePage(currentPage) {
            this.searchForm.pageNumber = currentPage;
            this.getAppList();
        },
        handleChangePageSize(pageSize) {
            this.searchForm.pageNumber = 1;
            this.searchForm.pageSize = pageSize;
            this.getAppList();
        },
        getAppList() {
            this.isLoading = true;
            this.getRequest("/df-wx/wxApp/getPage", this.searchForm)
            .then(res => {
                this.isLoading = false;
                let data = res.data;
                if(data.code == 200) {
                    this.appList = data.data.records;
                    this.total = data.data.total;
                }
            })
        }
    },
}

</script>

<style>
    @import url("./index.less");
</style>